module.exports = __webpack_public_path__ + "img/corn-bread-casserole-with-topping.13453860.jpg";